import ReturnHeaderMeta from "@dana/Components/StandardReturns/ReturnHeaderMeta";

import { ReturnOrderLineModel } from "@dana/Services/DanaStandardReturnOrderService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox from "@insite/mobius/Checkbox";
import DataTable from "@insite/mobius/DataTable";
import {
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
    Typography,
} from "@insite/mobius/index";
import TextField from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// --- Props Interface ---
interface StepConfirmItemsProps {
    selectedForReturn: ReturnOrderLineModel[];
}

// --- Styles Interfaces and Objects ---
export interface StepConfirmItemsStyles {
    subHeading?: TypographyPresentationProps;
    tableWrap?: InjectableCss;
}

export const StepConfirmItemsStyles: StepConfirmItemsStyles = {
    subHeading: {
        css: css`
            margin-top: 24px;
        `,
    },
    tableWrap: {
        css: css`
            overflow: auto;
        `,
    },
};

const styles = StepConfirmItemsStyles;
const mapStateToProps = (state: ApplicationStateDana) => {
    return {
        order: state.standardReturnState?.selectedOrder,
    };
};
type Props = ReturnType<typeof mapStateToProps> &
    StepConfirmItemsProps;
// --- Component Definition ---
const StepConfirmItems: FC<Props> = ({selectedForReturn }) => {
    const L_LINE = translate("Line No");
    const L_PART = translate("Part No.");
    const L_CPART = translate("Customer Part No.");
    const L_DESC = translate("Description");
    const L_OQTY = translate("Shipped Qty");
    const L_CQTY = translate("Return Item Qty");
    return (
        <>
            <ReturnHeaderMeta  />
            <StyledWrapper {...styles.tableWrap}>
                <DataTable>
                    <DataTableHead>
                        <DataTableHeader tight>{L_LINE}</DataTableHeader>
                        <DataTableHeader>{L_PART}</DataTableHeader>
                        <DataTableHeader>{L_CPART}</DataTableHeader>
                        <DataTableHeader>{L_DESC}</DataTableHeader>
                        <DataTableHeader>{L_OQTY}</DataTableHeader>
                        <DataTableHeader>{L_CQTY}</DataTableHeader>
                    </DataTableHead>
                    <DataTableBody>
                        {selectedForReturn?.map(line => (
                            <DataTableRow key={line.lineNumber}>
                                <DataTableCell>{line.lineNumber}</DataTableCell>
                                <DataTableCell>{line.productErpNumber}</DataTableCell>
                                <DataTableCell>{line.customerProductNumber}</DataTableCell>
                                <DataTableCell>{line.description}</DataTableCell>
                                <DataTableCell>{line.qtyShipped}</DataTableCell>
                                <DataTableCell>{line.returnItemQty}</DataTableCell>
                            </DataTableRow>
                        ))}
                    </DataTableBody>
                </DataTable>
            </StyledWrapper>
            <Typography {...styles.subHeading} as="p" className="text-center font-semibold">
                {translate("A restocking fee may apply. Refer to your order policy.")}
            </Typography>
        </>
    );
};

export default connect(mapStateToProps)(StepConfirmItems)

